module.exports = __webpack_public_path__ + "img/Pitcairn Islands.9b8d5c24.svg";